<div *ngIf="!this.showMessage && !this.showQuote">
  Loading...
</div>
<div *ngIf="this.showMessage || this.showQuote" class="card border-0 shadow w-auto">
  <div class="card-header">
    <img class="bidit-logo" alt="Dealer Logo" [src]="dealerLogo" *ngIf="!isLogoLoading" />
    <label *ngIf="!acknowledgement.changeOrder_ID" class="text-bidit-primary-header" i18n>Acknowledge Your Quote</label>
    <label *ngIf="acknowledgement.changeOrder_ID" class="text-bidit-primary-header" i18n>Acknowledge Your Change Order</label>
  </div>
  <div class="card-body">
    <div class="d-flex flex-column">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <p i18n *ngIf="!this.acknowledgement && this.showMessage">Unable to complete acknowledgement - contact your sales rep for assistance</p>
          <p i18n *ngIf="this.acknowledgement?.isExpired && this.acknowledgement?.acknowledgementStatus == 0">Link has expired, please contact your sales rep to get a new link</p>
          <div *ngIf="this.acknowledgement?.acknowledgedDate">
            <p *ngIf="!this.acknowledgement.changeOrder_ID" i18n>Quote has been previously acknowledged, please contact your sales rep for assistance</p>
            <p *ngIf="this.acknowledgement.changeOrder_ID" i18n>Change Order has been previously acknowledged, please contact your sales rep for assistance</p>
          </div>
          <div *ngIf="quoteRejected">
            <p *ngIf="!changeOrder" i18n>Your Quote has been acknowledged as Rejected</p>
            <p *ngIf="changeOrder" i18n>Your Change Order has been acknowledged as Rejected</p>
          </div>
          <div *ngIf="quoteAccepted">
            <p *ngIf="!changeOrder" i18n>Your Quote has been acknowledged as Accepted</p>
            <p *ngIf="changeOrder" i18n>Your Change Order has been acknowledged as Accepted</p>
          </div>

          <div class="scrollable" *ngIf="this.showQuote">
            <div *ngIf="isMobile" class="mobile">
              <div class="text-bidit-primary" *ngFor="let area of upgradeAreaSummaries">
                <div *ngIf="!area.area_IsOption">
                  <h5>{{area.area_Name}}</h5>
                  <div class="card border-bidit-dark">
                    <div class="card-body">
                      <div *ngFor="let lineItem of area.quoteAreas">
                        <div class="col">                          
                            <mat-radio-group name="area_IsAccepted{{lineItem.quoteArea_ID}}"
                                             [(ngModel)]="lineItem.area_RadioValue" #area_RadioValue="ngModel"
                                             (change)="calculateConversion()">
                              <mat-radio-button [value]="lineItem.quoteItem.quoteAreaItem_ID"></mat-radio-button>
                            </mat-radio-group>

                          <span *ngIf="lineItem.quoteItem.area_Name">{{lineItem.quoteItem.area_Name}}</span>
                          <span *ngIf="!lineItem.quoteItem.area_Name">{{lineItem.quoteItem.subArea.subArea_Name}}</span>

                          <div class="ms-3">
                            <label i18n class="">Item Type:</label>
                            <span> {{ lineItem.quoteItem.item == null ? "Custom Product" : lineItem.quoteItem.item?.itemType?.itemType_Desc}}</span>
                          </div>
                          <div class="ms-3">
                            <label i18n>R-Value: </label>
                            <span *ngIf="lineItem.quoteItem.itemUsage; then usageBlock; else rValueBlock"></span>
                            <span>
                              <ng-template #usageBlock>{{lineItem.quoteItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                              <ng-template #rValueBlock>
                                <span *ngIf="lineItem.quoteItem.item && lineItem.quoteItem.item.rValue">{{lineItem.quoteItem.item.rValue.rValue_Desc}}</span>
                              </ng-template>
                            </span>
                          </div>
                        </div>
                        <div *ngFor="let upgrade of lineItem.quoteUpgrades">
                          <div>
                            <mat-radio-group name="area_IsAccepted{{lineItem.quoteArea_ID}}"
                                             [(ngModel)]="lineItem.area_RadioValue" #area_RadioValue="ngModel"
                                             (change)="calculateConversion()">
                              <mat-radio-button [value]="upgrade.quoteAreaItem_ID"></mat-radio-button>
                            </mat-radio-group>
                            <strong i18n>ALTERNATE:</strong>
                            <div class="ms-3">
                              <label i18n class="">Item Type:</label>
                              <span> {{upgrade.item.itemType.itemType_Desc}}</span>
                            </div>
                            <div class="ms-3">
                              <label i18n>R-Value: </label>
                              <span *ngIf="lineItem.quoteItem.itemUsage; then usageBlock; else rValueBlock"></span>
                              <span>
                                <ng-template #usageBlock>{{upgrade.itemUsage.rValue.rValue_Desc}}</ng-template>
                                <ng-template #rValueBlock>
                                  <span *ngIf="lineItem.quoteItem.item && lineItem.quoteItem.item.rValue">{{lineItem.quoteItem.item.rValue.rValue_Desc}}</span>
                                </ng-template>
                              </span>
                            </div>
                          </div>
                          <div class="col">
                            <span class="float-right"><strong i18n>Estimate Change:</strong> ${{upgrade.upgradeBid | number: '1.2-2'}}</span><br>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="area.area_IsOption">
                  <div *ngFor="let areaOptionGroup of area.quoteAreaOptionGroups">
                    <span *ngIf="areaOptionGroup.optionGroup === null; then ungroupedOptionBlock; else groupOptionBlock"></span>
                    <ng-template #groupOptionBlock>
                      <h5>{{area.area_Name}} - Group {{areaOptionGroup.optionGroup}}</h5>
                      <mat-radio-group class="form-inline" name="area_IsAccepted{{areaOptionGroup.optionGroup}}"
                                       [(ngModel)]="areaOptionGroup.group_radioValue" #area_RadioValue="ngModel"
                                       (change)="setOptionGroupSelected(areaOptionGroup.optionGroup, areaOptionGroup.group_radioValue )">
                        <mat-radio-button [value]="1" i18n>Accept</mat-radio-button><br />
                        <mat-radio-button [value]="0" i18n>Decline</mat-radio-button>
                      </mat-radio-group>
                    </ng-template>

                    <ng-template #ungroupedOptionBlock>
                      <h5 class="mb-0">
                        {{area.area_Name}}
                      </h5>
                    </ng-template>
                    <div class="card border-bidit-dark">
                      <div class="card-body">
                        <ng-template ngFor let-lineItem [ngForOf]="areaOptionGroup.quoteAreaItems">
                          <div class="col">
                            <mat-radio-group class="form-inline" *ngIf="areaOptionGroup.optionGroup === null" name="area_IsAccepted{{lineItem.quoteArea_ID}}"
                                             [(ngModel)]="lineItem.area_IsAccepted" #lineItem.area_IsAccepted="ngModel"
                                             (change)="setOptionSelected(lineItem.quoteAreaItem_ID, lineItem.area_IsAccepted)">
                              <mat-radio-button [value]="true" i18n>Accept</mat-radio-button><br />
                              <mat-radio-button [value]="false" i18n>Decline</mat-radio-button>
                            </mat-radio-group>
                            <span *ngIf="lineItem.area_Name">{{lineItem.area_Name}}</span>
                            <span *ngIf="!lineItem.area_Name">{{lineItem.subArea.subArea_Name}}</span>

                            <div class="ms-3">
                              <label i18n class="">Item Type:</label>
                              <span> {{ lineItem.item == null ? "Custom Product" : lineItem.item?.itemType?.itemType_Desc}}</span>
                            </div>
                            <div class="ms-3">
                              <label i18n>R-Value: </label>
                              <span *ngIf="lineItem.itemUsage; then usageBlock; else rValueBlock"></span>
                              <span>
                                <ng-template #usageBlock>{{lineItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                                <ng-template #rValueBlock>
                                  <span *ngIf="lineItem.item && lineItem.item.rValue">{{lineItem.item.rValue.rValue_Desc}}</span>
                                </ng-template>
                              </span>
                            </div>
                            <div class="float-end">
                              <span><strong i18n>Estimate Change:</strong> ${{lineItem.optionBid | number:'1.2-2'}}</span>
                            </div>
                          </div><br>
                        </ng-template>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

            <div *ngIf="!isMobile">
              <div *ngFor="let area of upgradeAreaSummaries">
                <div *ngIf="!area.area_IsOption">
                  <h5>{{area.area_Name}}</h5>
                  <div *ngFor="let lineItem of area.quoteAreas">
                    <table class="table " width="100%">
                      <thead>
                        <tr>
                          <th  i18n>Accepted</th>
                          <th i18n>Name</th>
                          <th i18n>Item Type</th>
                          <th i18n>R-Value</th>
                          <th><span class="float-right" i18n>Estimate Change</span></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <mat-radio-group name="area_IsAccepted{{lineItem.quoteArea_ID}}"
                                             [(ngModel)]="lineItem.area_RadioValue" #area_RadioValue="ngModel"
                                             (change)="calculateConversion()">
                              <mat-radio-button [value]="lineItem.quoteItem.quoteAreaItem_ID"></mat-radio-button>
                            </mat-radio-group>
                          </td>
                          <td>
                            <span *ngIf="lineItem.quoteItem.area_Name">{{lineItem.quoteItem.area_Name}}</span>
                            <span *ngIf="!lineItem.quoteItem.area_Name">{{lineItem.quoteItem.subArea.subArea_Name}}</span>
                          </td>
                          <td>
                            <span id="lineItem.quoteItem.item?.itemType?.itemType_Desc">{{lineItem.quoteItem.item?.itemType?.itemType_Desc}}</span>
                          </td>
                          <td>
                            <span *ngIf="lineItem.quoteItem.itemUsage; then usageBlock; else rValueBlock"></span>
                            <ng-template #usageBlock>{{lineItem.quoteItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                            <ng-template #rValueBlock>
                              <span *ngIf="lineItem.quoteItem.item && lineItem.quoteItem.item.rValue">{{lineItem.quoteItem.item.rValue.rValue_Desc}}</span>
                            </ng-template>
                          </td>
                          <td>
                          </td>
                        </tr>
                        <tr *ngFor="let upgrade of lineItem.quoteUpgrades">
                          <td>
                            <mat-radio-group name="area_IsAccepted{{lineItem.quoteArea_ID}}"
                                             [(ngModel)]="lineItem.area_RadioValue" #area_RadioValue="ngModel"
                                             (change)="calculateConversion()">
                              <mat-radio-button [value]="upgrade.quoteAreaItem_ID"></mat-radio-button>
                            </mat-radio-group>
                          </td>
                          <td>
                            <strong i18n>ALTERNATE:</strong>
                          </td>
                          <td>
                            <div id="upgrade.item.itemType.itemType_Desc">{{upgrade.item.itemType.itemType_Desc}}</div>
                          </td>
                          <td>
                            <span *ngIf="upgrade.itemUsage; then usageBlock; else rValueBlock"></span>
                            <ng-template #usageBlock>{{upgrade.itemUsage.rValue.rValue_Desc}}</ng-template>
                            <ng-template #rValueBlock>{{upgrade.item.rValue.rValue_Desc}}</ng-template>
                          </td>
                          <td></td>
                          <td>
                            ${{upgrade.upgradeBid | number: '1.2-2'}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div *ngIf="area.area_IsOption">
                  <div *ngFor="let areaOptionGroup of area.quoteAreaOptionGroups">
                    <span *ngIf="areaOptionGroup.optionGroup === null; then ungroupedOptionBlock; else groupOptionBlock"></span>
                    <ng-template #groupOptionBlock>
                      <h5>{{area.area_Name}} - Group {{areaOptionGroup.optionGroup}}</h5>
                      <mat-radio-group class="form-inline" name="area_IsAccepted{{areaOptionGroup.optionGroup}}"
                                       [(ngModel)]="areaOptionGroup.group_radioValue" #area_RadioValue="ngModel"
                                       (change)="setOptionGroupSelected(areaOptionGroup.optionGroup, areaOptionGroup.group_radioValue )">
                        <mat-radio-button [value]="1" i18n>Accept</mat-radio-button><br />
                        <mat-radio-button [value]="0" i18n>Decline</mat-radio-button>
                      </mat-radio-group>
                    </ng-template>

                    <ng-template #ungroupedOptionBlock>
                      <h5 class="mb-0">
                        {{area.area_Name}}
                      </h5>
                    </ng-template>
                    <table class="table " width="100%">
                      <thead>
                        <tr>
                          <th *ngIf="areaOptionGroup.optionGroup === null"></th>
                          <th i18n>Name</th>
                          <th>Item Type</th>
                          <th i18n>R-Value</th>
                          <th><span class="float-right" i18n>Estimate Change</span></th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-template ngFor let-lineItem [ngForOf]="areaOptionGroup.quoteAreaItems">
                          <tr>
                            <td *ngIf="areaOptionGroup.optionGroup === null">
                              <mat-radio-group name="area_IsAccepted{{lineItem.quoteAreaItem_ID}}"
                                               [(ngModel)]="lineItem.area_IsAccepted" #lineItem.area_IsAccepted="ngModel"
                                               (change)="setOptionSelected(lineItem.quoteAreaItem_ID, lineItem.area_IsAccepted)">
                                <mat-radio-button [value]="true" i18n>Accept</mat-radio-button><br />
                                <mat-radio-button [value]="false" i18n>Decline</mat-radio-button>
                              </mat-radio-group>
                            </td>
                            <td>
                              <span *ngIf="lineItem.area_Name">{{lineItem.area_Name}}</span>
                              <span *ngIf="!lineItem.area_Name">{{lineItem.subArea.subArea_Name}}</span>
                            </td>
                            <td>
                              <span id="lineItem.item?.itemType?.itemType_Desc">{{lineItem.item?.itemType?.itemType_Desc}}</span>
                            </td>
                            <td>
                              <span *ngIf="lineItem.itemUsage; then usageBlock; else rValueBlock"></span>
                              <ng-template #usageBlock>{{lineItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                              <ng-template #rValueBlock>
                                <span *ngIf="lineItem.item && lineItem.item.rValue">{{lineItem.item.rValue.rValue_Desc}}</span>
                              </ng-template>
                            </td>
                            <td *ngIf="area.area_IsOption">
                              <span class="float-right">${{lineItem.optionBid | number:'1.2-2'}}</span>
                            </td>
                          </tr>
                        </ng-template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="quote.quote_ID && this.showQuote" align="center" class="estimate-pnl">
              <h5 align="center" i18n>ESTIMATE</h5>
              <table class="table table-bidit">
                <tbody>
                  <tr *ngIf="!changeOrder">
                    <td i18n>Bid Amount</td>
                    <td>${{quote.quote_BidAmount | number: '1.2'}}</td>
                  </tr>
                  <tr *ngIf="changeOrder">
                    <td i18n>Change Order Amount</td>
                    <td>${{changeOrder.changeOrder_BidAmount | number: '1.2'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-md-1"></div>
        </div>
      </div>
    </div>
    <div *ngIf="this.showQuote" class="card-footer">
      <div class="d-flex justify-content-center">
        <p class="text-wrap text-start" style="width: 70vw;" i18n>
          By Accepting or rejecting this quote contract electronically, you will be deemed to have acknowledged and
          agreed to the Quote Contract and Sales Terms and Conditions of the document.
        </p>
      </div>
      <div class="d-flex justify-content-center">
        <app-signature-pad (signedImage)="acknowlegementSigned($event)"></app-signature-pad>
      </div>
      <div class="text-end text-danger" *ngIf="isSignatureMissing" il8n>Signature is Required for Quote Acceptance</div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
      <div class="float-end">
        <button *ngIf="this.allowAccept" (click)="acceptQuote()" [disabled]="this.isRequesting" (pointerenter)="clearMessage()" class="btn btn-bidit-submit mr-1" i18n>Accept</button>
        <button (click)="rejectQuote()" class="btn btn-bidit-cancel" [disabled]="this.isRequesting" i18n>Reject</button>
      </div>
    </div>
  </div>
</div>
